import workspaceQuery from 'graphql/queries/purchases/SupplierReturnWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/purchases/SupplierReturnListQuery.graphql';
import instanceQuery from 'graphql/queries/purchases/SupplierReturnQuery.graphql';
import defaultQuery from 'graphql/queries/purchases/SupplierReturnDefault.graphql';
import mutationQuery from 'graphql/mutations/purchases/SupplierReturnMutation.graphql';
import fragment from 'graphql/fragments/purchases/SupplierReturnFragment.graphql';
import temporaryMutationQuery from 'graphql/mutations/purchases/SupplierReturnTempMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SupplierReturn: EntityType = {
  type: 'SupplierReturn',
  title: 'Supplier Returns',
  formUrl: '/Purchasing/Return/Details/',
  formTitle: 'Supplier Returns',
  workspaceUrl: '/Purchasing/Return/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderNumber',
    remoteFilter: true,
  },
  fragment,
  screenReference: 'SUPPLIER_RETURNS',
  actions: [
    {
      actionReference: 'PRINT_DEBIT_NOTE',
    },
  ],
};

export default SupplierReturn;
